import {Route, Routes} from "@angular/router";
import {
    ProductLineSearchPageComponent
} from "../catalogue/product-line/product-line-search-page/product-line-search-page.component";
import {HomePageComponent} from "./home-page/home-page.component";
import {ExtraSearchPageComponent} from "../catalogue/extras/extra-search-page/extra-search-page.component";
import {
    AccountTypeSearchPageComponent
} from "../accounts/account-type/account-type-search-page/account-type-search-page.component";
import {DiscountSearchPageComponent} from "../pricing/discount/discount-search-page/discount-search-page.component";
import {
    CompositeProductSearchPageComponent
} from "../catalogue/composite-product/composite-product-search-page/composite-product-search-page.component";
import {InventorySearchPageComponent} from "../stock/inventory/inventory-search-page/inventory-search-page.component";
import {
    PriceLevelSearchPageComponent
} from "../pricing/price-level/price-level-search-page/price-level-search-page.component";
import {LocationSearchPageComponent} from "../pos/location/location-search-page/location-search-page.component";
import {OutletSearchPageComponent} from "../pos/outlet/outlet-search-page/outlet-search-page.component";
import {
    InventoryGroupSearchPageComponent
} from "../stock/inventory-group-search-page/inventory-group-search-page/inventory-group-search-page.component";
import {SpecialSearchPageComponent} from "../pricing/special/special-search-page/special-search-page.component";
import {SupplierSearchPageComponent} from "../stock/supplier/supplier-search-page/supplier-search-page.component";
import {ContactSearchPageComponent} from "../contact/contact-search-page/contact-search-page.component";
import {AccountSearchPageComponent} from "../accounts/account/account-search-page/account-search-page.component";
import {EmployeeSearchPageComponent} from "../employee/employee/employee-search-page/employee-search-page.component";
import {PositionSearchPageComponent} from "../employee/position/position-search-page/position-search-page.component";
import {
    AccessRoleSearchPageComponent
} from "../employee/access-role/access-role-search-page/access-role-search-page.component";
import {TerminalSearchPageComponent} from "../pos/terminal/terminal-search-page/terminal-search-page.component";
import {
    PreparationModifierSearchPageComponent
} from "../catalogue/preparation-modifier/preparation-modifier-search-page/preparation-modifier-search-page.component";
import {ShiftSearchPageComponent} from "../employee/shift/shift-search-page/shift-search-page.component";
import {
    SizeGroupSearchPageComponent
} from "../catalogue/size-group/size-group-search-page/size-group-search-page.component";
import {SurchargeSearchPageComponent} from "../pricing/surcharge/surcharge-search-page/surcharge-search-page.component";
import {
    ManufacturerSearchPageComponent
} from "../stock/manufacturer/manufacturer-search-page/manufacturer-search-page.component";
import {MeasureSearchPageComponent} from "../stock/measure/measure-search-page/measure-search-page.component";
import {
    SizeGroupRelationSearchPageComponent
} from "../catalogue/size-group-relation/size-group-relation-search-page/size-group-relation-search-page.component";
import {
    MixAndMatchSearchPageComponent
} from "../pricing/mix-and-match/mix-and-match-search-page/mix-and-match-search-page.component";
import {
    MembershipTypeSearchPageComponent
} from "../customers/membership-type/membership-type-search-page/membership-type-search-page.component";
import {TaxSearchPageComponent} from "../system/tax/tax-search-page/tax-search-page.component";
import {
    EmailSettingSearchPageComponent
} from "../system/email-setting/email-setting-search-page/email-setting-search-page.component";
import {MemberSearchPageComponent} from "../customers/member/member-search-page/member-search-page.component";
import {
    SalesJournalSearchPageComponent
} from "../sale/sales-journal/sales-journal-search-page/sales-journal-search-page.component";
import {
    WebTerminalSearchPageComponent
} from "../pos/web-terminal/web-terminal-search-page/web-terminal-search-page.component";
import {
    SalePeriodSearchPageComponent
} from "../pos/sale-period/sale-period-search-page/sale-period-search-page.component";
import {
    CreditCardMappingSearchPageComponent
} from "../system/credit-card-mapping/credit-card-mapping-search-page/credit-card-mapping-search-page.component";
import {
    EventTriggerSearchPageComponent
} from "../system/event-trigger/event-trigger-search-page/event-trigger-search-page.component";
import {
    ScreenLayoutSearchPageComponent
} from "../pos/screen-layout/screen-layout-search-page/screen-layout-search-page.component";
import {
    FunctionBarSearchPageComponent
} from "../pos/function-bar/function-bar-search-page/function-bar-search-page.component";
import {
    TableLayoutSearchPageComponent
} from "../pos/table-layout/table-layout-search-page/table-layout-search-page.component";
import {PlgSearchPageComponent} from "../catalogue/plg/plg-search-page/plg-search-page.component";
import {
    MarketingCampaignSearchPageComponent
} from "../customers/marketing-campaign/marketing-campaign-search-page/marketing-campaign-search-page.component";
import {
    ProductContainerSearchPageComponent
} from "../catalogue/product-container/product-container-search-page/product-container-search-page.component";
import {
    CustomObjectTypeSearchPageComponent
} from "../custom-objects/custom-object-type/custom-object-type-search-page/custom-object-type-search-page.component";
import {
    CustomObjectSearchPageComponent
} from "../custom-objects/custom-object/custom-object-search-page/custom-object-search-page.component";
import {
    CashManagementSearchPageComponent
} from "../sale/cash-management/cash-management-search-page/cash-management-search-page.component";
import {
    ProductLineEditPageComponent
} from "../catalogue/product-line/product-line-edit-page/product-line-edit-page.component";
import {
    OrderProcessorSearchPageComponent
} from "../order-processing/order_processor/order-processor-search-page/order-processor-search-page.component";
import {EmployeeEditPageComponent} from "../employee/employee/employee-edit-page/employee-edit-page.component";
import {TerminalEditPageComponent} from "../pos/terminal/terminal-edit-page/terminal-edit-page.component";
import {LocationEditPageComponent} from "../pos/location/location-edit-page/location-edit-page.component";
import {
    ManufacturerEditPageComponent
} from "../stock/manufacturer/manufacturer-edit-page/manufacturer-edit-page.component";
import {
    InventoryGroupEditPageComponent
} from "../stock/inventory-group-search-page/inventory-group-edit-page/inventory-group-edit-page.component";
import {
    PriceLevelEditPageComponent
} from "../pricing/price-level/price-level-edit-page/price-level-edit-page.component";
import {SupplierEditPageComponent} from "../stock/supplier/supplier-edit-page/supplier-edit-page.component";
import {SurchargeEditPageComponent} from "../pricing/surcharge/surcharge-edit-page/surcharge-edit-page.component";
import {
    CompanyDetailsSearchPageComponent
} from "../system/company-details/company-details-search-page/company-details-search-page.component";
import {
    CompanyDetailsEditPageComponent
} from "../system/company-details/company-details-edit-page/company-details-edit-page.component";
import {OutletEditPageComponent} from "../pos/outlet/outlet-edit-page/outlet-edit-page.component";
import {MeasureEditPageComponent} from "../stock/measure/measure-edit-page/measure-edit-page.component";
import {PositionEditPageComponent} from "../employee/position/position-edit-page/position-edit-page.component";
import {PlgEditPageComponent} from "../catalogue/plg/plg-edit-page/plg-edit-page.component";
import {ContactEditPageComponent} from "../contact/contact-edit-page/contact-edit-page.component";
import {DiscountEditPageComponent} from "../pricing/discount/discount-edit-page/discount-edit-page.component";
import {ExtraEditPageComponent} from "../catalogue/extras/extra-edit-page/extra-edit-page.component";
import {
    MixAndMatchEditPageComponent
} from "../pricing/mix-and-match/mix-and-match-edit-page/mix-and-match-edit-page.component";
import {SpecialEditPageComponent} from "../pricing/special/special-edit-page/special-edit-page.component";
import {AccountEditPageComponent} from "../accounts/account/account-edit-page/account-edit-page.component";
import {
    AccountTypeEditPageComponent
} from "../accounts/account-type/account-type-edit-page/account-type-edit-page.component";
import {MemberEditPageComponent} from "../customers/member/member-edit-page/member-edit-page.component";
import {
    MembershipTypeEditPageComponent
} from "../customers/membership-type/membership-type-edit-page/membership-type-edit-page.component";
import {
    CompositeProductEditPageComponent
} from "../catalogue/composite-product/composite-product-edit-page/composite-product-edit-page.component";
import {
    PreparationModifierEditPageComponent
} from "../catalogue/preparation-modifier/preparation-modifier-edit-page/preparation-modifier-edit-page.component";
import {TaxEditPageComponent} from "../system/tax/tax-edit-page/tax-edit-page.component";
import {
    EmailSettingEditPageComponent
} from "../system/email-setting/email-setting-edit-page/email-setting-edit-page.component";
import {
    ProductContainerEditPageComponent
} from "../catalogue/product-container/product-container-edit-page/product-container-edit-page.component";
import {
    MembershipTypeCustomObjectSearchPageComponent
} from "../custom-objects/custom-object/custom-object-search-page/membership-type-custom-object-search-page.component";
import {
    InventoryCustomObjectSearchPageComponent
} from "../custom-objects/custom-object/custom-object-search-page/inventory-custom-object-search-page.component";
import {
    ProductLineCustomObjectSearchPageComponent
} from "../custom-objects/custom-object/custom-object-search-page/product-line-custom-object-search-page.component";
import {
    OutletCustomObjectSearchPageComponent
} from "../custom-objects/custom-object/custom-object-search-page/outlet-custom-object-search-page.component";
import {SalePeriodEditPageComponent} from "../pos/sale-period/sale-period-edit-page/sale-period-edit-page.component";
import {
    CustomObjectTypeEditPageComponent
} from "../custom-objects/custom-object-type/custom-object-type-edit-page/custom-object-type-edit-page.component";
import {
    CustomObjectEditPageComponent
} from "../custom-objects/custom-object/custom-object-edit-page/custom-object-edit-page.component";
import {
    InventoryCustomObjectTypeSearchPageComponent
} from "../custom-objects/custom-object-type/custom-object-type-search-page/inventory-custom-object-type-search-page.component";
import {
    MembershipTypeCustomObjectTypeSearchPageComponent
} from "../custom-objects/custom-object-type/custom-object-type-search-page/membership-type-custom-object-type-search-page.component";
import {
    ProductLineCustomObjectTypeSearchPageComponent
} from "../custom-objects/custom-object-type/custom-object-type-search-page/product-line-custom-object-type-search-page.component";
import {
    OutletCustomObjectTypeSearchPageComponent
} from "../custom-objects/custom-object-type/custom-object-type-search-page/outlet-custom-object-type-search-page.component";
import {
    MembershipTypeCustomObjectEditPageComponent
} from "../custom-objects/custom-object/custom-object-edit-page/membership-type-custom-object-edit-page.component";
import {
    ProductLineCustomObjectEditPageComponent
} from "../custom-objects/custom-object/custom-object-edit-page/product-line-custom-object-edit-page.component";
import {
    OutletCustomObjectEditPageComponent
} from "../custom-objects/custom-object/custom-object-edit-page/outlet-custom-object-edit-page.component";
import {
    InventoryCustomObjectEditPageComponent
} from "../custom-objects/custom-object/custom-object-edit-page/inventory-custom-object-edit-page.component";
import {
    MembershipTypeCustomObjectTypeEditPageComponent
} from "../custom-objects/custom-object-type/custom-object-type-edit-page/membership-type-custom-object-type-edit-page.component";
import {
    InventoryCustomObjectTypeEditPageComponent
} from "../custom-objects/custom-object-type/custom-object-type-edit-page/inventory-custom-object-type-edit-page.component";
import {
    OutletCustomObjectTypeEditPageComponent
} from "../custom-objects/custom-object-type/custom-object-type-edit-page/outlet-custom-object-type-edit-page.component";
import {
    ProductLineCustomObjectTypeEditPageComponent
} from "../custom-objects/custom-object-type/custom-object-type-edit-page/product-line-custom-object-type-edit-page.component";
import {
    AccessRoleEditPageComponent
} from "../employee/access-role/access-role-edit-page/access-role-edit-page.component";
import {MyreportSearchPageComponent} from "../reports/myreport/myreport-search-page/myreport-search-page.component";
import {
    StockLevelSearchPageComponent
} from "../stock/stock-level/stock-level-search-page/stock-level-search-page.component";
import {
    PurchaseOrderSearchPageComponent
} from "../stock/purchase-order/purchase-order-search-page/purchase-order-search-page.component";
import {
    ReceiveOrderSearchPageComponent
} from "../stock/receive-order/receive-order-search-page/receive-order-search-page.component";
import {
    CreditOrderSearchPageComponent
} from "../stock/credit-order/credit-order-search-page/credit-order-search-page.component";
import {
    CreditInvoiceSearchPageComponent
} from "../stock/credit-invoice/credit-invoice-search-page/credit-invoice-search-page.component";
import {
    SupplierInvoiceSearchPageComponent
} from "../stock/supplier-invoice/supplier-invoice-search-page/supplier-invoice-search-page.component";
import {
    SalesJournalEditPageComponent
} from "../sale/sales-journal/sales-journal-edit-page/sales-journal-edit-page.component";
import {
    StockTakeSearchPageComponent
} from "../stock/stock-take/stock-take-search-page/stock-take-search-page.component";
import {
    StockTransferSearchPageComponent
} from "../stock/stock-transfer/stock-transfer-search-page/stock-transfer-search-page.component";
import {LicenseSearchPageComponent} from "../system/license/license-search-page/license-search-page.component";
import {CanDeactivateEditPage} from "../framework/entity/edit/edit-page/can-deactivate-edit-page";
import {SizeGroupEditPageComponent} from "../catalogue/size-group/size-group-edit-page/size-group-edit-page.component";
import {
    TableDefinitionSearchPageComponent
} from "../pos/table-definition/table-definition-search-page/table-definition-search-page.component";
import {
    ReasonCodeSearchPageComponent
} from "../sale/reason-code/reason-code-search-page/reason-code-search-page.component";
import {ReasonCodeEditPageComponent} from "../sale/reason-code/reason-code-edit-page/reason-code-edit-page.component";
import {
    SizeGroupRelationEditPageComponent
} from "../catalogue/size-group-relation/size-group-relation-edit-page/size-group-relation-edit-page.component";
import {ShiftEditPageComponent} from "../employee/shift/shift-edit-page/shift-edit-page.component";
import {
    PreparationResourceTypeSearchPageComponent
} from "../order-processing/preparation-resource-type/preparation-resource-type-search-page/preparation-resource-type-search-page.component";
import {
    PreparationResourceTypeEditPageComponent
} from "../order-processing/preparation-resource-type/preparation-resource-type-edit-page/preparation-resource-type-edit-page.component";
import {
    TableDefinitionEditPageComponent
} from "../pos/table-definition/table-definition-edit-page/table-definition-edit-page.component";
import {ProductPluReportPageComponent} from "../catalogue/reports/productplu/product-plu-report-page.component";
import {InventoryEditPageComponent} from "../stock/inventory/inventory-edit-page/inventory-edit-page.component";
import {ConsolidationReportComponent} from "../sale/reports/consolidation-report/consolidation-report.component";
import {
    BalanceTillSummaryReportComponent
} from "../sale/reports/balance-till-summary-report/balance-till-summary-report.component";
import {
    BalanceTillBreakdownReportComponent
} from "../sale/reports/balance-till-breakdown-report/balance-till-breakdown-report.component";
import {
    BestWorstSellersReportComponent
} from "../sale/reports/best-worst-sellers-report/best-worst-sellers-report.component";
import {
    ProductSaleAuditReportComponent
} from "../sale/reports/product-sale-audit-report/product-sale-audit-report.component";
import {
    StockMovementAuditReportComponent
} from "../stock/reports/stock-movement-audit-report/stock-movement-audit-report.component";
import {DetailedSalesReportComponent} from "../sale/reports/detailed-sales-report/detailed-sales-report.component";
import {
    AccountSummaryReportComponent
} from "../accounts/reports/account-summary-report/account-summary-report.component";
import {AccItemStmtReportComponent} from "../accounts/reports/acc-item-stmt-report/acc-item-stmt-report.component";
import {
    CashManagementEditPageComponent
} from "../sale/cash-management/cash-management-edit-page/cash-management-edit-page.component";
import {AccSingleInvReportComponent} from "../accounts/reports/acc-single-inv-report/acc-single-inv-report.component";
import {
    AccountInvoiceSearchPageComponent
} from "../accounts/account-invoice/account-invoice-search-page/account-invoice-search-page.component";
import {CategorySearchPageComponent} from "../catalogue/category/category-search-page/category-search-page.component";
import {CategoryEditPageComponent} from "../catalogue/category/category-edit-page/category-edit-page.component";
import {
    WebTerminalEditPageComponent
} from "../pos/web-terminal/web-terminal-edit-page/web-terminal-edit-page.component";
import {
    PriceLevelAuditReportComponent
} from "../sale/reports/price-level-audit-report/price-level-audit-report.component";
import {VoidAuditReportComponent} from "../sale/reports/void-audit-report/void-audit-report.component";
import {
    ProductPriceLevelReportPageComponent
} from "../catalogue/reports/productpricelevel/product-price-level-report-page.component";
import {
    ProductCostingBomReportPageComponent
} from "../catalogue/reports/productcostingbom/product-costing-bom-report-page.component";
import {
    SalesByHalfHourReportComponent
} from "../sale/reports/sales-by-half-hour-report/sales-by-half-hour-report.component";
import {SalesByHourReportComponent} from "../sale/reports/sales-by-hour-report/sales-by-hour-report.component";
import {
    SalesByPaymentTypeReportComponent
} from "../sale/reports/sales-by-payment-type-report/sales-by-payment-type-report.component";
import {SalesAuditReportComponent} from "../sale/reports/sales-audit-report/sales-audit-report.component";
import {
    ProductWastageReportPageComponent
} from "../catalogue/reports/productwastage/product-wastage-report-page.component";
import {
    ProductSaleCostingReportComponent
} from "../sale/reports/product-sale-costing-report/product-sale-costing-report.component";
import {
    OrderAssignmentRuleSearchPageComponent
} from "../order-processing/order_assignment-rule/order-assignment-rule-search-page/order-assignment-rule-search-page.component";
import {
    OrderAssignmentRuleEditPageComponent
} from "../order-processing/order_assignment-rule/order-assignment-rule-edit-page/order-assignment-rule-edit-page.component";
import {StockWastageReportComponent} from "../stock/reports/stock-wastage-report/stock-wastage-report.component";
import {CanDeactivateStackedModal} from "../framework/entity/edit/edit-page/can-deactivate-stacked-modal";
import {DashboardViewPageComponent} from "../bi/dashboard/dashboard-view-page/dashboard-view-page.component";
import {DashboardEditPageComponent} from "../bi/dashboard/dashboard-edit-page/dashboard-edit-page.component";
import {PivotGridViewPageComponent} from "../bi/pivot-grid/pivot-grid-view-page/pivot-grid-view-page.component";
import {PivotGridEditPageComponent} from "../bi/pivot-grid/pivot-grid-edit-page/pivot-grid-edit-page.component";
import {
    EntitlementSearchPageComponent
} from "../pricing/entitlement/entitlement-search-page/entitlement-search-page.component";
import {
    EntitlementEditPageComponent
} from "../pricing/entitlement/entitlement-edit-page/entitlement-edit-page.component";
import {SurchargeAuditReportComponent} from "../sale/reports/surcharge-audit-report/surcharge-audit-report.component";
import {
    StockBatchValuationReportComponent
} from "../stock/reports/stock-batch-valuation-report/stock-batch-valuation-report.component";
import {
    StockInTransitReportComponent
} from "../stock/reports/stock-in-transit-report/stock-in-transit-report.component";
import {OpenItemReportComponent} from "../sale/reports/open-item-report/open-item-report.component";
import {StockTransferReportComponent} from "../stock/reports/stock-transfer-report/stock-transfer-report.component";
import {
    StockReplenishmentReportComponent
} from "../stock/reports/stock-replenishment-report/stock-replenishment-report.component";
import {AccReceivableReportComponent} from "../accounts/reports/acc-receivable-report/acc-receivable-report.component";
import {BasketAnalysisReportComponent} from "../sale/reports/basket-analysis-report/basket-analysis-report.component";
import {DiscountAuditReportComponent} from "../sale/reports/discount-audit-report/discount-audit-report.component";
import {StockUsageReportComponent} from "../stock/reports/stock-usage-report/stock-usage-report.component";
import {OutgoingsReportComponent} from "../accounts/reports/outgoings-report/outgoings-report.component";
import {
    EmployeeDetailsReportPageComponent
} from "../employee/employee/reports/employee-details-report/employee-details-report-page.component";
import {
    EmployeePerformanceReportPageComponent
} from "../employee/employee/reports/employee-performance-report/employee-performance-report-page.component";
import {
    EmployeePhonListReportPageComponent
} from "../employee/employee/reports/employee-phon-list-report/employee-phon-list-report-page.component";
import {StockValuationReportComponent} from "../stock/reports/stock-valuation-report/stock-valuation-report.component";
import {
    EmployeeTimeCardReportPageComponent
} from "../employee/employee/reports/employee-time-card-report/employee-time-card-report-page.component";
import {
    ErrorCorrectReportPageComponent
} from "../sale/reports/error-correct-report/error-correct-report-page.component";
import {ExpAccDetailReportComponent} from "../accounts/reports/exp-acc-detail-report/exp-acc-detail-report.component";
import {
    MemberLoyaltySignupReportComponent
} from "../customers/reports/member-loyalty-signup-report/member-loyalty-signup-report.component";
import {
    ExtraSalesSummaryReportPageComponent
} from "../sale/reports/extra-sales-summary-report/extra-sales-summary-report-page.component";
import {
    SchedulePromotionReportPageComponent
} from "../pricing/reports/schedule-promotion-report/schedule-promotion-report-page.component";
import {UncountedStockReportComponent} from "../stock/reports/uncounted-stock-report/uncounted-stock-report.component";
import {TabReportComponent} from "../sale/reports/tab-report/tab-report.component";
import {TableReportComponent} from "../sale/reports/table-report/table-report.component";
import {MemberDetailsReportComponent} from "../customers/reports/member-details-report/member-details-report.component";
import {
    InventoryBarcodeReportComponent
} from "../stock/reports/inventory-barcode-report/inventory-barcode-report.component";
import {MemberLoyaltyReportComponent} from "../customers/reports/member-loyalty-report/member-loyalty-report.component";
import {
    ProductBarcodeReportComponent
} from "../catalogue/reports/product-barcode-report/product-barcode-report.component";
import {InvoiceSummaryReportComponent} from "../stock/reports/invoice-summary-report/invoice-summary-report.component";
import {
    OrderHistoryAuditReportComponent
} from "../sale/reports/order-history-audit-report/order-history-audit-report.component";
import {StockTakeReportComponent} from "../stock/reports/stock-take-report/stock-take-report.component";
import {MyreportEditPageComponent} from "../reports/myreport/myreport-edit-page/myreport-edit-page.component";
import {CustomReportComponent} from "../reports/custom-reports/custom-report/custom-report.component";
import {
    ScreenLayoutEditPageComponent
} from "../pos/screen-layout/screen-layout-edit-page/screen-layout-edit-page.component";
import {
    PriceLevelScheduleSearchPageComponent
} from "../pricing/price-level-schedule/price-level-schedule-search-page/price-level-schedule-search-page.component";
import {
    SpecialScheduleSearchPageComponent
} from "../pricing/special-schedule/special-schedule-search-page/special-schedule-search-page.component";
import {
    MixAndMatchScheduleSearchPageComponent
} from "../pricing/mix-and-match-schedule/mix-and-match-schedule-search-page/mix-and-match-schedule-search-page.component";
import {
    PriceLevelScheduleEditPageComponent
} from "../pricing/price-level-schedule/price-level-schedule-edit-page/price-level-schedule-edit-page.component";
import {
    SpecialScheduleEditPageComponent
} from "../pricing/special-schedule/special-schedule-edit-page/special-schedule-edit-page.component";
import {
    MixAndMatchScheduleEditPageComponent
} from "../pricing/mix-and-match-schedule/mix-and-match-schedule-edit-page/mix-and-match-schedule-edit-page.component";
import {
    CourseDefinitionSearchPageComponent
} from "../pos/course-definition/course-definition-search-page/course-definition-search-page.component";
import {
    CourseDefinitionEditPageComponent
} from "../pos/course-definition/course-definition-edit-page/course-definition-edit-page.component";
import {FileImportPageComponent} from "../system/file-import/file-import-page/file-import-page.component";
import {
    PeriodScheduleSearchPageComponent
} from "../system/period-schedule/period-schedule-search-page/period-schedule-search-page.component";
import {
    PeriodScheduleEditPageComponent
} from "../system/period-schedule/period-schedule-edit-page/period-schedule-edit-page.component";
import {
    AppLayoutFileImportPageComponent
} from "../system/file-import/app-layout-file-import-page/app-layout-file-import-page.component";
import {
    LoyaltyCardSearchPageComponent
} from "../customers/loyalty-card/loyalty-card-search-page/loyalty-card-search-page.component";
import {
    LoyaltyCardEditPageComponent
} from "../customers/loyalty-card/loyalty-card-edit-page/loyalty-card-edit-page.component";
import {ExtrasSoldReportComponent} from "../sale/reports/extras-sold-report/extras-sold-report.component";
import {
    DocketPrintingRuleSearchPageComponent
} from "../order-processing/docket-printing-rule/docket-printing-rule-search-page/docket-printing-rule-search-page.component";
import {
    DocketPrintingRuleEditPageComponent
} from "../order-processing/docket-printing-rule/docket-printing-rule-edit-page/docket-printing-rule-edit-page.component";
import {
    KitchenDisplaySearchPageComponent
} from "../order-processing/kitchen-display/kitchen-display-search-page/kitchen-display-search-page.component";
import {
    KitchenDisplayEditPageComponent
} from "../order-processing/kitchen-display/kitchen-display-edit-page/kitchen-display-edit-page.component";
import {
    SalesByCategoryReportComponent
} from "../sale/reports/sales-by-category-report/sales-by-category-report.component";
import {ReconciliationReportComponent} from "../sale/reports/reconciliation-report/reconciliation-report.component";
import {
    OptInMarketingSearchPageComponent
} from "../customers/opt-in-marketing/opt-in-marketing-search-page/opt-in-marketing-search-page.component";
import {
    DietaryIndicatorSearchPageComponent
} from "../catalogue/dietary-indicator/dietary-indicator-search-page/dietary-indicator-search-page.component";
import {
    DietaryIndicatorEditPageComponent
} from "../catalogue/dietary-indicator/dietary-indicator-edit-page/dietary-indicator-edit-page.component";
import {
    OrderActionDisplaySearchPageComponent
} from "../order-processing/order-action-display/order-action-display-search-page/order-action-display-search-page.component";
import {
    OrderActionDisplayEditPageComponent
} from "../order-processing/order-action-display/order-action-display-edit-page/order-action-display-edit-page.component";
import {
    OrderReadyDisplaySearchPageComponent
} from "../order-processing/order-ready-display/order-ready-display-search-page/order-ready-display-search-page.component";
import {
    OrderReadyDisplayEditPageComponent
} from "../order-processing/order-ready-display/order-ready-display-edit-page/order-ready-display-edit-page.component";
import {
    AppItemAvailabilitySearchPageComponent
} from "../web-ordering/app-item-availability/app-item-availability-search-page/app-item-availability-search-page.component";
import {
    DocketSelectorSearchPageComponent
} from "../order-processing/docket-selector/docket-selector-search-page/docket-selector-search-page.component";
import {
    DocketSelectorEditPageComponent
} from "../order-processing/docket-selector/docket-selector-edit-page/docket-selector-edit-page.component";
import {
    OrderReadyQualifierSearchPageComponent
} from "../order-processing/order-ready-qualifier/order-ready-qualifier-search-page/order-ready-qualifier-search-page.component";
import {
    OrderReadyQualifierEditPageComponent
} from "../order-processing/order-ready-qualifier/order-ready-qualifier-edit-page/order-ready-qualifier-edit-page.component";
import {
    IntegratedInstanceSearchPageComponent
} from "../api/integrated-instance/integrated-instance-search-page/integrated-instance-search-page.component";
import {
    DocketSelectorAuditReportPageComponent
} from "../catalogue/reports/docketselectoraudit/docket-selector-audit-report-page.component";
import {ProductsSoldReportComponent} from "../sale/reports/products-sold-report/products-sold-report.component";

export interface EditRoute extends Route {
    /**
     * Edit path is used to add edit pages to the routing. It will include two entries, one for the id and another one to add new entities.
     */
    editPath?: string;
    nameSpace?: string;
    entity?: string;
    singleton?: boolean;
}

export let MainRoutes: EditRoute[];
MainRoutes = [
    {
        path: "",
        pathMatch: "full",
        redirectTo: "home"
    },
    {
        component: CategorySearchPageComponent,
        path: "category-search"
    },
    {
        component: CategoryEditPageComponent,
        editPath: "category"
    },
    {
        component: ProductLineSearchPageComponent,
        path: "product-line-search"
    },
    {
        component: ProductLineEditPageComponent,
        editPath: "product-line"
    },
    {
        component: HomePageComponent,
        path: "home"
    },
    {
        component: ExtraSearchPageComponent,
        path: "extra-search"
    },
    {
        component: ExtraEditPageComponent,
        editPath: "extra"
    },
    {
        component: DietaryIndicatorSearchPageComponent,
        path: "dietary-indicator-search"
    },
    {
        component: DietaryIndicatorEditPageComponent,
        editPath: "dietary-indicator"
    },
    {
        component: AccountTypeSearchPageComponent,
        path: "account-type-search"
    },
    {
        component: AccountTypeEditPageComponent,
        editPath: "account-type"
    },
    {
        component: DiscountSearchPageComponent,
        path: "discount-search"
    },
    {
        component: DiscountEditPageComponent,
        editPath: "discount"
    },
    {
        component: EntitlementSearchPageComponent,
        path: "deal-search",
        entity: "entitlement"
    },
    {
        component: EntitlementEditPageComponent,
        editPath: "deal",
        entity: "entitlement"
    },
    {
        component: CompositeProductSearchPageComponent,
        path: "composite-product-search"
    },
    {
        component: CompositeProductEditPageComponent,
        editPath: "composite-product"
    },
    {
        component: InventorySearchPageComponent,
        path: "inventory-search"
    },
    {
        component: PeriodScheduleSearchPageComponent,
        path: "period-schedule-search"
    },
    {
        component: PeriodScheduleEditPageComponent,
        editPath: "period-schedule"
    },
    {
        component: PriceLevelSearchPageComponent,
        path: "price-level-search"
    },
    {
        component: PriceLevelEditPageComponent,
        editPath: "price-level"
    },
    {
        component: PriceLevelScheduleSearchPageComponent,
        path: "price-level-schedule-search"
    },
    {
        component: PriceLevelScheduleEditPageComponent,
        editPath: "price-level-schedule"
    },
    {
        component: ScreenLayoutEditPageComponent,
        editPath: "screen-layout"
    },
    {
        component: LocationSearchPageComponent,
        path: "location-search"
    },
    {
        component: LocationEditPageComponent,
        editPath: "location"
    },
    {
        component: OutletSearchPageComponent,
        path: "outlet-search"
    },
    {
        component: OutletEditPageComponent,
        editPath: "outlet"
    },
    {
        component: InventoryGroupSearchPageComponent,
        path: "inventory-group-search"
    },
    {
        component: InventoryGroupEditPageComponent,
        editPath: "inventory-group"
    },
    {
        component: SpecialSearchPageComponent,
        path: "special-search"
    },
    {
        component: SpecialEditPageComponent,
        editPath: "special"
    },
    {
        component: SupplierSearchPageComponent,
        path: "supplier-search"
    },
    {
        component: SupplierEditPageComponent,
        editPath: "supplier"
    },
    {
        component: SpecialScheduleSearchPageComponent,
        path: "special-schedule-search"
    },
    {
        component: SpecialScheduleEditPageComponent,
        editPath: "special-schedule"
    },
    {
        component: ContactSearchPageComponent,
        path: "contact-search"
    },
    {
        component: ContactEditPageComponent,
        editPath: "contact"
    },
    {
        component: OptInMarketingSearchPageComponent,
        path: "opt-in-marketing-search"
    },
    {
        component: AccountSearchPageComponent,
        path: "account-search"
    },
    {
        component: AccountEditPageComponent,
        editPath: "account"
    },
    {
        component: EmployeeSearchPageComponent,
        path: "employee-search"
    },
    {
        component: EmployeeEditPageComponent,
        editPath: "employee"
    },
    {
        component: PositionSearchPageComponent,
        path: "position-search"
    },
    {
        component: PositionEditPageComponent,
        editPath: "position"
    },
    {
        component: AccessRoleSearchPageComponent,
        path: "access-role-search"
    },
    {
        component: AccessRoleEditPageComponent,
        editPath: "access-role"
    },
    {
        component: TerminalSearchPageComponent,
        path: "terminal-search"
    },
    {
        component: TerminalEditPageComponent,
        editPath: "terminal"
    },
    {
        component: CourseDefinitionSearchPageComponent,
        path: "course-search",
        entity: "course-definition"
    },
    {
        component: CourseDefinitionEditPageComponent,
        editPath: "course",
        entity: "course-definition"
    },
    {
        component: OrderProcessorSearchPageComponent,
        path: "order-processor-search"
    },
    {
        component: DocketPrintingRuleSearchPageComponent,
        path: "docket-printing-rule-search"
    },
    {
        component: DocketPrintingRuleEditPageComponent,
        editPath: "docket-printing-rule"
    },
    {
        component: KitchenDisplaySearchPageComponent,
        path: "kitchen-display-search"
    },
    {
        component: KitchenDisplayEditPageComponent,
        editPath: "kitchen-display"
    },
    {
        component: OrderActionDisplaySearchPageComponent,
        path: "order-action-display-search"
    },
    {
        component: OrderActionDisplayEditPageComponent,
        editPath: "order-action-display"
    },
    {
        component: OrderReadyDisplaySearchPageComponent,
        path: "order-ready-display-search"
    },
    {
        component: OrderReadyDisplayEditPageComponent,
        editPath: "order-ready-display"
    },
    {
        component: OrderAssignmentRuleSearchPageComponent,
        path: "order-assignment-rule-search"
    },
    {
        component: OrderAssignmentRuleEditPageComponent,
        editPath: "order-assignment-rule"
    },
    {
        component: PreparationModifierSearchPageComponent,
        path: "preparation-modifier-search",
        entity: "meta-tag-definition"
    },
    {
        component: PreparationModifierEditPageComponent,
        editPath: "preparation-modifier",
        entity: "meta-tag-definition"
    },
    {
        component: DocketSelectorSearchPageComponent,
        path: "docket-selector-search",
        entity: "meta-tag-definition"
    },
    {
        component: DocketSelectorEditPageComponent,
        editPath: "docket-selector",
        entity: "meta-tag-definition"
    },
    {
        component: OrderReadyQualifierSearchPageComponent,
        path: "order-ready-qualifier-search",
        entity: "meta-tag-definition"
    },
    {
        component: OrderReadyQualifierEditPageComponent,
        editPath: "order-ready-qualifier",
        entity: "meta-tag-definition"
    },
    {
        component: ShiftSearchPageComponent,
        path: "shift-search"
    },
    {
        component: SizeGroupSearchPageComponent,
        path: "size-group-search"
    },
    {
        component: SurchargeSearchPageComponent,
        path: "surcharge-search"
    },
    {
        component: SurchargeEditPageComponent,
        editPath: "surcharge"
    },
    {
        component: ManufacturerSearchPageComponent,
        path: "manufacturer-search"
    },
    {
        component: ManufacturerEditPageComponent,
        editPath: "manufacturer"
    },
    {
        component: MeasureSearchPageComponent,
        path: "measure-search"
    },
    {
        component: MeasureEditPageComponent,
        editPath: "measure"
    },
    {
        component: SizeGroupRelationSearchPageComponent,
        path: "size-group-relation-search"
    },
    {
        component: MixAndMatchSearchPageComponent,
        path: "mix-and-match-search"
    },
    {
        component: MixAndMatchEditPageComponent,
        editPath: "mix-and-match"
    },
    {
        component: MixAndMatchScheduleSearchPageComponent,
        path: "mix-and-match-schedule-search"
    },
    {
        component: MixAndMatchScheduleEditPageComponent,
        editPath: "mix-and-match-schedule"
    },
    {
        component: MembershipTypeSearchPageComponent,
        path: "membership-type-search"
    },
    {
        component: MembershipTypeEditPageComponent,
        editPath: "membership-type"
    },
    {
        component: CompanyDetailsSearchPageComponent,
        path: "company-details-search"
    },
    {
        component: CompanyDetailsEditPageComponent,
        editPath: "company-details"
    },
    {
        component: TaxSearchPageComponent,
        path: "tax-search"
    },
    {
        component: TaxEditPageComponent,
        editPath: "tax"
    },
    {
        component: EmailSettingSearchPageComponent,
        path: "email-setting-search"
    },
    {
        component: EmailSettingEditPageComponent,
        editPath: "email-setting"
    },
    {
        component: MemberSearchPageComponent,
        path: "member-search"
    },
    {
        component: MemberEditPageComponent,
        editPath: "member"
    },
    {
        component: SalesJournalSearchPageComponent,
        path: "sales-journal-search"
    },
    {
        component: SalesJournalEditPageComponent,
        editPath: "sales-journal"
    },
    {
        component: SalesJournalSearchPageComponent,
        path: "sales-maintenance-search",
        data: {maintenance: true}
    },
    {
        component: SalesJournalEditPageComponent,
        editPath: "sales-maintenance",
        data: {maintenance: true}
    },
    {
        component: ReasonCodeSearchPageComponent,
        path: "reason-code-search"
    },
    {
        component: ReasonCodeEditPageComponent,
        editPath: "reason-code"
    },
    {
        component: AppItemAvailabilitySearchPageComponent,
        path: "web-ordering-item-availability-search",
        entity: "app-item-availability"
    },
    {
        component: WebTerminalSearchPageComponent,
        path: "web-terminal-search"
    },
    {
        component: WebTerminalEditPageComponent,
        editPath: "web-terminal"
    },
    {
        component: SalePeriodSearchPageComponent,
        path: "sale-period-search"
    },
    {
        component: SalePeriodEditPageComponent,
        editPath: "sale-period"
    },
    {
        component: CreditCardMappingSearchPageComponent,
        path: "credit-card-mapping-search"
    },
    {
        component: EventTriggerSearchPageComponent,
        path: "event-trigger-search"
    },
    {
        component: ScreenLayoutSearchPageComponent,
        path: "screen-layout-search"
    },
    {
        component: FunctionBarSearchPageComponent,
        path: "function-bar-search"
    },
    {
        component: TableLayoutSearchPageComponent,
        path: "table-layout-search"
    },
    {
        component: PlgSearchPageComponent,
        path: "composite-option-group-search",
        entity: "plg"
    },
    {
        component: PlgEditPageComponent,
        editPath: "composite-option-group",
        entity: "plg"
    },
    {
        component: MarketingCampaignSearchPageComponent,
        path: "marketing-campaign-search"
    },
    {
        component: LoyaltyCardSearchPageComponent,
        path: "loyalty-card-search"
    },
    {
        component: LoyaltyCardEditPageComponent,
        editPath: "loyalty-card"
    },
    {
        component: ProductContainerSearchPageComponent,
        path: "product-container-search"
    },
    {
        component: ProductContainerEditPageComponent,
        editPath: "product-container"
    },
    {
        component: CustomObjectTypeEditPageComponent,
        editPath: "custom-group-type",
        entity: "custom-object-type"
    },
    {
        component: MembershipTypeCustomObjectTypeEditPageComponent,
        editPath: "custom-membership-group-type",
        entity: "custom-object-type"
    },
    {
        component: InventoryCustomObjectTypeEditPageComponent,
        editPath: "custom-inventory-group-type",
        entity: "custom-object-type"
    },
    {
        component: ProductLineCustomObjectTypeEditPageComponent,
        editPath: "custom-product-group-type",
        entity: "custom-object-type"
    },
    {
        component: OutletCustomObjectTypeEditPageComponent,
        editPath: "custom-outlet-group-type",
        entity: "custom-object-type"
    },
    {
        component: CustomObjectTypeSearchPageComponent,
        path: "custom-group-type-search"
    },
    {
        component: MembershipTypeCustomObjectTypeSearchPageComponent,
        path: "custom-membership-group-type-search"
    },
    {
        component: InventoryCustomObjectTypeSearchPageComponent,
        path: "custom-inventory-group-type-search"
    },
    {
        component: ProductLineCustomObjectTypeSearchPageComponent,
        path: "custom-product-group-type-search"
    },
    {
        component: OutletCustomObjectTypeSearchPageComponent,
        path: "custom-outlet-group-type-search"
    },
    {
        component: CustomObjectEditPageComponent,
        editPath: "custom-group",
        entity: "custom-object"
    },
    {
        component: MembershipTypeCustomObjectEditPageComponent,
        editPath: "custom-membership-group",
        entity: "custom-object"
    },
    {
        component: InventoryCustomObjectEditPageComponent,
        editPath: "custom-inventory-group",
        entity: "custom-object"
    },
    {
        component: ProductLineCustomObjectEditPageComponent,
        editPath: "custom-product-group",
        entity: "custom-object"
    },
    {
        component: OutletCustomObjectEditPageComponent,
        editPath: "custom-outlet-group",
        entity: "custom-object"
    },
    {
        component: CustomObjectSearchPageComponent,
        path: "custom-group-search"
    },
    {
        component: MembershipTypeCustomObjectSearchPageComponent,
        path: "custom-membership-group-search"
    },
    {
        component: InventoryCustomObjectSearchPageComponent,
        path: "custom-inventory-group-search"
    },
    {
        component: ProductLineCustomObjectSearchPageComponent,
        path: "custom-product-group-search"
    },
    {
        component: OutletCustomObjectSearchPageComponent,
        path: "custom-outlet-group-search"
    },
    {
        component: CashManagementSearchPageComponent,
        path: "cash-management-search"
    },
    {
        component: MyreportSearchPageComponent,
        path: "myreport-search"
    },
    {
        component: MyreportEditPageComponent,
        editPath: "myreport"
    },
    {
        component: ProductPluReportPageComponent,
        path: "product-plu-report"
    },
    {
        component: DocketSelectorAuditReportPageComponent,
        path: "docket-selector-audit-report"
    },
    {
        component: ProductsSoldReportComponent,
        path: "products-sold-report"
    },
    {
        component: StockLevelSearchPageComponent,
        path: "stock-level-search"
    },
    {
        component: PurchaseOrderSearchPageComponent,
        path: "purchase-order-search"
    },
    {
        component: ReceiveOrderSearchPageComponent,
        path: "receive-order-search"
    },
    {
        component: CreditOrderSearchPageComponent,
        path: "credit-order-search"
    },
    {
        component: CreditInvoiceSearchPageComponent,
        path: "credit-invoice-search"
    },
    {
        component: SupplierInvoiceSearchPageComponent,
        path: "supplier-invoice-search"
    },
    {
        component: StockTakeSearchPageComponent,
        path: "stock-take-search"
    },
    {
        component: StockTransferSearchPageComponent,
        path: "stock-transfer-search"
    },
    {
        component: LicenseSearchPageComponent,
        path: "license-search"
    },
    {
        component: SizeGroupEditPageComponent,
        editPath: "size-group"
    },
    {
        component: TableDefinitionSearchPageComponent,
        path: "table-definition-search"
    },
    {
        component: SizeGroupRelationEditPageComponent,
        editPath: "size-group-relation"
    },
    {
        component: ShiftEditPageComponent,
        editPath: "shift"
    },
    {
        component: PreparationResourceTypeSearchPageComponent,
        path: "preparation-resource-type-search"
    },
    {
        component: PreparationResourceTypeEditPageComponent,
        editPath: "preparation-resource-type"
    },
    {
        component: TableDefinitionEditPageComponent,
        editPath: "table-definition"
    },
    {
        component: InventoryEditPageComponent,
        editPath: "inventory"
    },
    {
        component: ConsolidationReportComponent,
        path: "consolidation-report"
    },
    {
        component: ReconciliationReportComponent,
        path: "reconciliation-report"
    },
    {
        component: BalanceTillSummaryReportComponent,
        path: "balance-till-summary-report"
    },
    {
        component: BalanceTillBreakdownReportComponent,
        path: "balance-till-breakdown-report"
    },
    {
        component: BasketAnalysisReportComponent,
        path: "basket-analysis-report"
    },
    {
        component: BestWorstSellersReportComponent,
        path: "best-worst-sellers-report"
    },
    {
        component: ProductSaleAuditReportComponent,
        path: "product-sale-audit-report"
    },
    {
        component: StockMovementAuditReportComponent,
        path: "stock-movement-audit-report"
    },
    {
        component: StockBatchValuationReportComponent,
        path: "stock-batch-valuation-report"
    },
    {
        component: InventoryBarcodeReportComponent,
        path: "inventory-barcode-report"
    },
    {
        component: StockInTransitReportComponent,
        path: "stock-in-transit-report"
    },
    {
        component: StockReplenishmentReportComponent,
        path: "stock-replenishment-report"
    },
    {
        component: StockUsageReportComponent,
        path: "stock-usage-report"
    },
    {
        component: StockValuationReportComponent,
        path: "stock-valuation-report"
    },
    {
        component: UncountedStockReportComponent,
        path: "uncounted-stock-report"
    },
    {
        component: InvoiceSummaryReportComponent,
        path: "invoice-summary-report"
    },
    {
        component: StockTakeReportComponent,
        path: "stock-take-report"
    },
    {
        component: DetailedSalesReportComponent,
        path: "detailed-sales-report"
    },
    {
        component: ErrorCorrectReportPageComponent,
        path: "error-correct-report"
    },
    {
        component: ExtraSalesSummaryReportPageComponent,
        path: "extra-sales-summary-report"
    },
    {
        component: AccountSummaryReportComponent,
        path: "account-summary-report"
    },
    {
        component: ExpAccDetailReportComponent,
        path: "exp-acc-detail-report"
    },
    {
        component: OutgoingsReportComponent,
        path: "outgoings-report"
    },
    {
        component: AccItemStmtReportComponent,
        path: "acc-item-stmt-report"
    },
    {
        component: AccReceivableReportComponent,
        path: "acc-receivable-report"
    },
    {
        component: CashManagementEditPageComponent,
        editPath: "cash-management"
    },
    {
        component: AccSingleInvReportComponent,
        path: "acc-single-inv-report"
    },
    {
        component: AccountInvoiceSearchPageComponent,
        path: "account-invoice-search"
    },
    {
        component: PriceLevelAuditReportComponent,
        path: "price-level-audit-report"
    },
    {
        component: VoidAuditReportComponent,
        path: "void-audit-report"
    },
    {
        component: ProductPriceLevelReportPageComponent,
        path: "product-price-level-report"
    },
    {
        component: ProductCostingBomReportPageComponent,
        path: "product-costing-bom-report"
    },
    {
        component: ProductBarcodeReportComponent,
        path: "product-barcode-report"
    },
    {
        component: SalesByCategoryReportComponent,
        path: "sales-by-category-report"
    },
    {
        component: SalesByHalfHourReportComponent,
        path: "sales-by-half-hour-report"
    },
    {
        component: SalesByHourReportComponent,
        path: "sales-by-hour-report"
    },
    {
        component: SalesByPaymentTypeReportComponent,
        path: "sales-by-payment-type-report"
    },
    {
        component: SalesAuditReportComponent,
        path: "sales-audit-report"
    },
    {
        component: OrderHistoryAuditReportComponent,
        path: "order-history-audit-report"
    },
    {
        component: TabReportComponent,
        path: "tab-report"
    },
    {
        component: TableReportComponent,
        path: "table-report"
    },
    {
        component: ProductWastageReportPageComponent,
        path: "product-wastage-report"
    },
    {
        component: ProductSaleCostingReportComponent,
        path: "product-sale-costing-report"
    },
    {
        component: StockWastageReportComponent,
        path: "stock-wastage-report"
    },
    {
        component: StockTransferReportComponent,
        path: "stock-transfer-report"
    },
    {
        component: SurchargeAuditReportComponent,
        path: "surcharge-audit-report"
    },
    {
        component: DiscountAuditReportComponent,
        path: "discount-audit-report"
    },
    {
        component: OpenItemReportComponent,
        path: "open-item-report"
    },
    {
        component: SchedulePromotionReportPageComponent,
        path: "schedule-promotion-report"
    },
    {
        component: EmployeeDetailsReportPageComponent,
        path: "employee-details-report"
    },
    {
        component: EmployeePhonListReportPageComponent,
        path: "employee-phon-list-report"
    },
    {
        component: EmployeePerformanceReportPageComponent,
        path: "employee-performance-report"
    },
    {
        component: EmployeeTimeCardReportPageComponent,
        path: "employee-time-card-report"
    },
    {
        component: DashboardViewPageComponent,
        path: "dashboard/:id"
    },
    {
        component: DashboardEditPageComponent,
        editPath: "dashboard-edit"
    },
    {
        component: PivotGridViewPageComponent,
        path: "pivot/:id"
    },
    {
        component: PivotGridEditPageComponent,
        editPath: "pivot-edit"
    },
    {
        component: MemberLoyaltySignupReportComponent,
        path: "member-loyalty-signup-report"
    },
    {
        component: MemberDetailsReportComponent,
        path: "member-details-report"
    },
    {
        component: MemberLoyaltyReportComponent,
        path: "member-loyalty-report"
    },
    {
        component: CustomReportComponent,
        path: "custom-report/:reportId"
    },
    {
        component: CustomReportComponent,
        path: "custom-report"
    },
    {
        component: FileImportPageComponent,
        path: "file-import"
    },
    {
        component: AppLayoutFileImportPageComponent,
        path: "web-ordering-menu-import"
    },
    {
        component: ExtrasSoldReportComponent,
        path: "extras-sold-report"
    },
    {
        component: IntegratedInstanceSearchPageComponent,
        path: "integrated-instance-search"
    }
];

export function buildRoutes(): Routes {
    const editRoutes = MainRoutes;
    const routes: Routes = [];

    editRoutes.forEach((editRoute) => {
        if (editRoute.editPath) {
            editRoute.path = editRoute.editPath + (editRoute.singleton ? "" : "/:id");
            if (!editRoute.canDeactivate) {
                editRoute.canDeactivate = [CanDeactivateStackedModal, CanDeactivateEditPage];
            }
        } else {
            editRoute.canDeactivate = [CanDeactivateStackedModal];
        }
        routes.push(editRoute);
    });

    return routes;
}
